import { Skeleton } from 'antd';
import React from 'react';

const ChatPageSkeleton = () => {
  return (
    <div style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px'
    }}>
      {/* Match chat messages container dimensions */}
      <div style={{ 
        flex: 1, 
        overflow: 'hidden',
        maxWidth: '800px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        {/* Message skeleton 1 */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </div>
        </div>
        
        {/* Message skeleton 2 */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 3 }} />
          </div>
        </div>
        
        {/* Message skeleton 3 */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <Skeleton.Avatar active size={32} />
          <div style={{ flex: 1 }}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </div>
        </div>
      </div>
      
      {/* Input area skeleton - also centered and constrained */}
      <div style={{ 
        marginTop: 'auto', 
        paddingTop: 16,
        maxWidth: '800px',
        width: '100%'
      }}>
        <Skeleton.Input 
          active 
          style={{ width: '100%', height: 80 }} 
          block 
        />
      </div>
    </div>
  );
};

export default ChatPageSkeleton;
